
import { defineComponent } from "vue";
import "@/assets/scss/doctors/patients-list.scss";
import axios from "axios";
import LoadingScreen from "@/components/LoadingScreen.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "versions",
  components: { LoadingScreen },
  data() {
    return {
      isLoading: true,
      active: false,
      red: "red",
      success: "green",
      yellow: "yellow",
      activeModel: false,
      patients: [],
    };
  },
  methods: {
    createdVersion() {
      this.active = false;
      this.activeModel = true;
    },
    changeStatus() {
      console.log("jfjfjfّ");
    },
    showRecords(id: number) {
      this.$router.push({
        name: "patients-records",
        params: { id: id },
      });
    },
    showVersion(id: number) {
      this.$router.push({
        name: "patients-versions",
        params: { id: id },
      });
    },
    fetchPatients() {
      axios
        .get("doctor/patients")
        .then((res) => {
          // console.log(res);

          this.patients = res.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.fetchPatients();
  },
});
